module.exports = __webpack_public_path__ + "static/media/notification.2ade5fe7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification.mp3
// module id = 1571
// module chunks = 0